import { Card } from "primereact/card";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useEffect, useMemo, useState } from "react";


const LeftContent = ({ handleLeftCalculations, mortgageMonthlyExpenses,setTableView , features}) => {
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  const navigate = useNavigate();
  const types = ["Home Ownership", "Investment"];
  const portfoilios = [
    "Real Estate",
    "Stock Market",
    "Commodities",
    "Cryptocurrency",
    "Accounts"
  ];
  const transactions = ["Permit and Work History", "Payments"];
  const milestones = ["Life Events", "Depletion"];
  
  

  const [subscriptionData, setSubscriptionData] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [featureAccessMap, setFeatureAccessMap] = useState(null);
  const [active, setActive] = useState(null);
  const { pathname } = useLocation();

  const gotoTab = (type) => {
    if (setTableView !== undefined) {
      setTableView(true);
    }
    if (!clientId || clientId === "null") {
      if (type === "Home Ownership") {
        navigate(`/home-purchase/step3/tab1`);
      } else if (type == "Real Estate") {
        navigate(`/home-purchase/portfolio/realestate`);
      }  else if (type == "Stock Market") {
        navigate(`/home-purchase/portfolio/financials`);
      } else if (type == "Commodities") {
        navigate(`/home-purchase/portfolio/commodities`);
      } else if (type == "Cryptocurrency") {
        navigate(`/home-purchase/portfolio/crypto`);
      } else if (type == "Accounts") {
        navigate(`/home-purchase/portfolio/accounts`);
      } else if (type == "Investment") {
        navigate(`/home-purchase/investment/analysis`); 
      } else if (type == "Permit and Work History") {
        navigate(`/home-purchase/transactions/workhistory`); 
      }  else if (type == "Payments") {
        navigate(`/home-purchase/transactions/payments`); 
      } else if (type == "Subscription") {
        navigate(`/home-purchase/subscription`); 
      } else if (type == "Life Events") {
        navigate(`/home-purchase/milestone/lifeevents`); 
      } else if (type == "Depletion") {
        navigate(`/home-purchase/milestone/depletion`); 
      } 
    } else {
      if (type === "Home Ownership") {
        navigate(`/home-purchase/step3/tab1/?clientid=${clientId}`);
      } else if (type == "Real Estate") {
        navigate(`/home-purchase/portfolio/realestate/?clientid=${clientId}`);
      }  else if (type == "Stock Market") {
        navigate(`/home-purchase/portfolio/financials/?clientid=${clientId}`);
      } else if (type == "Commodities") {
        navigate(`/home-purchase/portfolio/commodities/?clientid=${clientId}`);
      } else if (type == "Cryptocurrency") {
        navigate(`/home-purchase/portfolio/crypto/?clientid=${clientId}`);
      } else if (type == "Accounts") {
        navigate(`/home-purchase/portfolio/accounts/?clientid=${clientId}`);
      } else if (type == "Investment") {
        navigate(`/home-purchase/investment/analysis/?clientid=${clientId}`); 
      } else if (type == "Permit and Work History") {
        navigate(`/home-purchase/transactions/workhistory/?clientid=${clientId}`); 
      }  else if (type == "Payments") {
        navigate(`/home-purchase/transactions/payments/?clientid=${clientId}`); 
      }  else if (type == "Subscription") {
        navigate(`/home-purchase/subscription/?clientid=${clientId}`); 
      }  else if (type == "Life Events") {
        navigate(`/home-purchase/milestone/lifeevents/?clientid=${clientId}`); 
      }  else if (type == "Subscription") {
        navigate(`/home-purchase/milestone/depletion/?clientid=${clientId}`); 
      } 
    }
  };
// Also run on component mount to load subscription data
  useEffect(() => {
    const stored = sessionStorage.getItem("subscriptionData");
    
    if (stored && stored !== "null" && stored !== "undefined" && stored.trim() !== "") {
      try {
        const parsedData = JSON.parse(stored);
        setSubscriptionData(parsedData);
        
        const featureAccessMap = parsedData?.features?.reduce((acc, f) => {
          acc[f.name] = f.access;
          return acc;
        }, {});
        setFeatureAccessMap(featureAccessMap);
        
        const { currentPlan } = parsedData;
        setCurrentPlan(currentPlan);
      } catch (error) {
        console.error("Error parsing subscription data:", error);
        console.log("Using default subscription data");
        setSubscriptionData({
          currentPlan: 'Basic',
          features: []
        });
        setFeatureAccessMap({});
        setCurrentPlan('Basic');
      }
    } else {
      console.log("Initial load - no subscription data found, using default");
      // Set default values when no subscription data exists
      setSubscriptionData({
        currentPlan: 'Basic',
        features: []
      });
      setFeatureAccessMap({});
      setCurrentPlan('Basic');
    }
  }, []); // Run only once on mount
  useEffect(() => {
    if (pathname.includes("/home-purchase/step3") || pathname.includes("/home-value")) {
      setActive(types[0]);
    } else if (pathname.includes("/home-purchase/investment") || pathname.includes("/capital-growth-estimation")) {
      setActive(types[1]);
    } else if (
      pathname.includes("/home-purchase/portfolio/realestate") ||
      pathname.includes("/home-purchase/portfolio/propertydetails")
    ) {
      setActive(portfoilios[0]);
    } else if (pathname.includes("/home-purchase/portfolio/propertydetails")) {
      setActive(portfoilios[1]);
    } else if (
      pathname.includes("/home-purchase/portfolio/financials") 
    ) {
      setActive(portfoilios[1]);
    } else if (
      pathname.includes("/home-purchase/portfolio/commodities") 
    ) {
      setActive(portfoilios[2]);
    } else if (
      pathname.includes("/home-purchase/portfolio/crypto") 
    ) {
      setActive(portfoilios[3]);
    } else if (
      pathname.includes("/home-purchase/portfolio/accounts") 
    ) {
      setActive(portfoilios[4]);
    } else if (pathname.includes("/home-purchase/transactions/workhistory")) {
      setActive(transactions[0]);
    } else if (pathname.includes("/home-purchase/transactions/payments")) {
      setActive(transactions[1]);
    } else if (pathname.includes("/home-purchase/milestone/lifeevents")) {
      setActive(milestones[0]);
    } else if (pathname.includes("/home-purchase/milestone/depletion")) {
      setActive(milestones[1]);
    }

  }, [pathname]); // This runs on mount and when pathname changes

  if (!subscriptionData) {
    console.log("subscriptionData is null, showing default navigation");

  }

  

  return (
    <Card>
      
      <div>
        {/* Vertical Navigation Tabs */}
        <nav className="tabs">
          <ul>
            <li>
              <NavLink
                to="/home-purchase/step3/tab1"
                className={`${
                  active === "Analyze and Design" ||
                  window.location.hash.indexOf("/home-purchase/step3") > 0 ||
                  window.location.hash.indexOf("/investment") > 1 || 
                  window.location.hash.indexOf("/capital-growth-estimation") > 1 ||
                  window.location.hash.indexOf("/home-value") > 0
                    ? "nav-item active"
                    : "nav-item"
                }`}
              >
                Analyze and Design
              </NavLink>
              <div className="tabs">
                <div className="tabs-nav">
                  
                   {types.map((type) => {
                    const featureName = featureAccessMap?.[type];
                 
                    const isAllowed = featureName && currentPlan && featureName[currentPlan] === true;
                    
                    return (
                      <div
                        key={type}
                        id={type}
                        className={`nav-item ${
                          active === type ? "active" : ""
                        } ${!isAllowed ? "disabled" : ""}`}
                          style={{
                          color: !isAllowed ? "darkgrey" : "inherit",
                          cursor: !isAllowed ? "text" : "pointer",
                        }}
                        onClick={() => {
                          if (!isAllowed) return;   // ?? block only this tab
                          gotoTab(type);            // ? allow
                        }}
                      >
                        {type}
                      </div>
                    
                    );
                  })}
                </div>
              </div>
            </li>
            {(() => {
              const accessiblePortfolios = portfoilios.filter((type) => {
                const featureName = featureAccessMap?.[type];
                return featureName && currentPlan && featureName[currentPlan] === true;
              });
              
              return accessiblePortfolios.length > 0 && (
                <li>
                  <NavLink
                    to="/home-purchase/portfolio/realestate"
                    className={`${
                      active === "Portfolio" ||
                      window.location.hash.indexOf("/portfolio") > 1
                        ? "nav-item active"
                        : "nav-item"
                    }`}
                  >
                    Portfolio
                  </NavLink>
                  <div className="tabs">
                    <div className="tabs-nav">
                      {accessiblePortfolios.map((type) => {
                        return (
                          <div
                            key={type}
                            id={type}
                            className={`nav-item ${
                              active === type ? "active" : ""
                            }`}
                            onClick={() => {
                              gotoTab(type);
                            }}
                          >
                            {type}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </li>
              );
            })()}
            {(() => {
              const accessibleTransactions = transactions.filter((type) => {
                const featureName = featureAccessMap?.[type];
                return featureName && currentPlan && featureName[currentPlan] === true;
              });
              
              return accessibleTransactions.length > 0 && (
                <li>
                  <NavLink
                    to="/home-purchase/transactions/workhistory"
                    className={`${
                      active === "Transactions" ||
                      window.location.hash.indexOf("/transactions") > 1
                        ? "nav-item active"
                        : "nav-item"
                    }`}
                  >
                    Transactions
                  </NavLink>
                  <div className="tabs">
                    <div className="tabs-nav">
                      {accessibleTransactions.map((type) => {
                        return (
                          <div
                            key={type}
                            id={type}
                            className={`nav-item ${
                              active === type ? "active" : ""
                            }`}
                            onClick={() => {
                              gotoTab(type);
                            }}
                          >
                            {type}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </li>
              );
            })()}

            {(() => {
              const accessibleMilestones = milestones.filter((type) => {
                const featureName = featureAccessMap?.[type];
                return featureName && currentPlan && featureName[currentPlan] === true;
              });
              
              return accessibleMilestones.length > 0 && (
                <li>
                  <NavLink
                    to="/home-purchase/milestone/lifeevents"
                    className={`${
                      active === "Milestone Maps" ||
                      window.location.hash.indexOf("/milestone") > 1
                        ? "nav-item active"
                        : "nav-item"
                    }`}
                  >
                    Milestone Maps
                  </NavLink>
                  <div className="tabs">
                    <div className="tabs-nav">
                      {accessibleMilestones.map((type) => {
                        return (
                          <div
                            key={type}
                            id={type}
                            className={`nav-item ${
                              active === type ? "active" : ""
                            }`}
                            onClick={() => {
                              gotoTab(type);
                            }}
                          >
                            {type}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </li>
              );
            })()}
              {featureAccessMap?.["Reports"]?.[currentPlan] && (
                <li>
                  <NavLink 
                    to="/home-purchase/report/list" 
                    className={`${
                      window.location.hash.includes("report") && !window.location.hash.includes("reports")? "nav-item active" : "nav-item"
                    }`}
                    onClick={() => {
                      gotoTab("Reports");
                    }}
                  >
                    Reports
                  </NavLink>
                </li>
              )}
          </ul>
        </nav>

        {/* Content for the selected tab */}
      </div>
    </Card>
  );
};

export default LeftContent;
